import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  getAttributionAvailability,
  getAttributionReport,
  getAttributionStudents,
  getAttributionTimeline,
  updateAttributionConfig,
  createAttributionNextStep,
  updateAttributionNextStep,
  deleteAttributionNextStep,
  reorderAttributionNextSteps,
} from "src/web-services";
import {
  AttributionReportCreators as Creators,
  AttributionReportTypes as Types,
} from "../actions";

const authTokenSelector = state => state.user.authToken;

export function* requestAvailability() {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      getAttributionAvailability,
      authToken,
    );
    yield put(
      Creators.getAttributionAvailabilitySuccess(response.data),
    );
  } catch (error) {
    yield put(Creators.getAttributionAvailabilityFailure());
  }
}

export function* requestReport(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      getAttributionReport,
      authToken,
      action.cycle,
      action.preview,
    );
    yield put(Creators.getAttributionReportSuccess(response.data));
  } catch (error) {
    yield put(Creators.getAttributionReportFailure());
  }
}

export function* requestStudents(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      getAttributionStudents,
      authToken,
      action.cycle,
      action.params,
    );
    yield put(Creators.getAttributionStudentsSuccess(response.data));
  } catch (error) {
    yield put(Creators.getAttributionStudentsFailure());
  }
}

export function* requestTimeline(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      getAttributionTimeline,
      authToken,
      action.cycle,
      action.userId,
      action.preview,
    );
    yield put(Creators.getAttributionTimelineSuccess(response.data));
  } catch (error) {
    yield put(Creators.getAttributionTimelineFailure());
  }
}

export function* requestUpdateConfig(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      updateAttributionConfig,
      authToken,
      action.cycle,
      action.changes,
    );
    yield put(
      Creators.updateAttributionConfigSuccess(response.data.config),
    );
  } catch (error) {
    yield put(Creators.updateAttributionConfigFailure());
  }
}

export function* requestCreateNextStep(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      createAttributionNextStep,
      authToken,
      action.cycle,
      action.step,
    );
    yield put(
      Creators.attributionNextStepsSuccess(response.data.next_steps),
    );
  } catch (error) {
    yield put(Creators.attributionNextStepsFailure());
  }
}

export function* requestUpdateNextStep(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      updateAttributionNextStep,
      authToken,
      action.cycle,
      action.id,
      action.changes,
    );
    yield put(
      Creators.attributionNextStepsSuccess(response.data.next_steps),
    );
  } catch (error) {
    yield put(Creators.attributionNextStepsFailure());
  }
}

export function* requestDeleteNextStep(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      deleteAttributionNextStep,
      authToken,
      action.cycle,
      action.id,
    );
    yield put(
      Creators.attributionNextStepsSuccess(response.data.next_steps),
    );
  } catch (error) {
    yield put(Creators.attributionNextStepsFailure());
  }
}

export function* requestReorderNextSteps(action) {
  try {
    const authToken = yield select(authTokenSelector);
    const response = yield call(
      reorderAttributionNextSteps,
      authToken,
      action.cycle,
      action.orderedIds,
    );
    yield put(
      Creators.attributionNextStepsSuccess(response.data.next_steps),
    );
  } catch (error) {
    yield put(Creators.attributionNextStepsFailure());
  }
}

export function* watchAttributionReportRequests() {
  yield takeLatest(
    Types.GET_ATTRIBUTION_AVAILABILITY_REQUEST,
    requestAvailability,
  );
  yield takeLatest(
    Types.GET_ATTRIBUTION_REPORT_REQUEST,
    requestReport,
  );
  yield takeLatest(
    Types.GET_ATTRIBUTION_STUDENTS_REQUEST,
    requestStudents,
  );
  yield takeLatest(
    Types.GET_ATTRIBUTION_TIMELINE_REQUEST,
    requestTimeline,
  );
  yield takeLatest(
    Types.UPDATE_ATTRIBUTION_CONFIG_REQUEST,
    requestUpdateConfig,
  );
  yield takeLatest(
    Types.CREATE_ATTRIBUTION_NEXT_STEP_REQUEST,
    requestCreateNextStep,
  );
  yield takeLatest(
    Types.UPDATE_ATTRIBUTION_NEXT_STEP_REQUEST,
    requestUpdateNextStep,
  );
  yield takeLatest(
    Types.DELETE_ATTRIBUTION_NEXT_STEP_REQUEST,
    requestDeleteNextStep,
  );
  yield takeLatest(
    Types.REORDER_ATTRIBUTION_NEXT_STEPS_REQUEST,
    requestReorderNextSteps,
  );
}
